
export const dayShortCap = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
export const dayShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
export const dayLong = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
export const monthShort = ["Jan ", "Feb ", "Mar ", "Apr ", "May ", "Jun ", "Jul ", "Aug ", "Sep ", "Oct ", "Nov ", "Dec "]
export const monthLong = ["January ", "February ", "March ", "April ", "May ", "June ", "July ", "August ", "September ", "October ", "November ", "December "]